<div class="thank-you-wrapper d-flex align-items-center justify-content-center animated fadeIn">
  <div class="card thank-you-card text-center p-4 p-md-5">
    <div class="card-body">

      <!-- Big Logo -->
      <div class="thank-you-logo-container mb-4">
        <!-- Option A: Standard Image Logo -->
        <img src="{{ successLogo }}" alt="Colonnade Logo" class="thank-you-logo img-fluid" *ngIf="successLogo"/>

         <i class="fa fa-check-circle text-success thank-you-icon" *ngIf="!successLogo"></i>
      </div>

      <!-- Title -->
      <h2 class="thank-you-title mb-3 font-weight-bold">
        {{ 'COLONNADE_ONLINE_THANK_YOU_TITLE' | translate }}
      </h2>

      <!-- Message -->
      <p class="thank-you-message text-muted mb-4 lead">
        {{ 'COLONNADE_ONLINE_THANK_YOU_MESSAGE' | translate }}
      </p>

    </div>
  </div>
</div>
